import { render, staticRenderFns } from "./LinkedSolicitationCard.vue?vue&type=template&id=4086c8c2&scoped=true&"
import script from "./LinkedSolicitationCard.vue?vue&type=script&lang=js&"
export * from "./LinkedSolicitationCard.vue?vue&type=script&lang=js&"
import style0 from "./LinkedSolicitationCard.vue?vue&type=style&index=0&id=4086c8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086c8c2",
  null
  
)

export default component.exports